<template>
  <div id="main">
    <header id="header-box">
      <v-header></v-header>
    </header>
    <main class="main">
      <router-view/>
    </main>
    <footer id="footer-box" class="">
      <v-footer></v-footer>
    </footer>

    <v-ai-chat></v-ai-chat>
  </div>
</template>

<script>

import Header from '@/components/header_v2/index.vue'
import Footer from '@/components/footer/index.vue'
import AiChatPopUp from '@/modules/aiChatPopup/index.vue'
// import jQuery from 'jquery'
export default {
  name: "Main",
  components: {
    'v-header': Header,
    'v-footer': Footer,
    'v-ai-chat': AiChatPopUp
  },
  data(){
    return{
      addBG: false
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.main{
  min-height: 80vh;
  position: relative;
  overflow: hidden;
}
.bg-main{
  background: #ba0c2f;
}
@media screen and (max-width: 600px){
  .main{
    min-height: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Main.vue